/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { T, SYSTEM_LISTS_DEFAULTS } from "../../lib/globals";
import { Btn, Badge, Input, Textarea } from "../ui";
import { fmtDate } from "../../lib/formatters";

function ColActionButtons({ svc, myName, show, colAction, requestMaterials, conclude, justifyDelay, setDetailSvc }) {
  const [schedDate,      setSchedDate]      = useState(svc.scheduledDate||"");
  const [matList,        setMatList]        = useState([{name:"",qty:1,unit:"un"}]);
  const [concNote,       setConcNote]       = useState("");
  const [concPhotos,     setConcPhotos]     = useState([]);
  const [showMatForm,    setShowMatForm]    = useState(false);
  const [showConcForm,   setShowConcForm]   = useState(false);
  const [showDelayForm,  setShowDelayForm]  = useState(false);
  const [selectedJust,   setSelectedJust]   = useState(null);
  const [customJust,     setCustomJust]     = useState("");

  const isOverdue = svc.deadline && new Date(svc.deadline) < new Date();

  const s = svc.status;

  return(
    <div style={{display:"flex",flexDirection:"column",gap:8}}>
      {s==="Emitido"&&(
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:120}}>
            <Input type="date" value={schedDate} onChange={e=>setSchedDate(e.target.value)} placeholder="Data de execução"/>
          </div>
          <Btn onClick={()=>{
            if(!schedDate){show("Informe a data de execução.","error");return;}
            colAction(svc,"Agendado",`Data: ${fmtDate(schedDate)}`,{scheduledDate:schedDate});
          }}>📅 Agendar</Btn>
          <Btn variant="ghost" onClick={()=>colAction(svc,"Em Execução","Iniciado imediatamente")}>⚡ Iniciar Agora</Btn>
        </div>
      )}
      {s==="Agendado"&&(
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <Btn onClick={()=>colAction(svc,"Em Execução","Serviço iniciado")}>⚡ Iniciar Execução</Btn>
          <Btn variant="ghost" onClick={()=>setShowMatForm(!showMatForm)}>📦 Solicitar Material</Btn>
        </div>
      )}
      {s==="Em Execução"&&(
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <Btn variant="ghost" onClick={()=>setShowDelayForm(!showDelayForm)}>⏸️ Pausar Tarefa</Btn>
          <Btn onClick={()=>setShowConcForm(!showConcForm)} style={{background:`linear-gradient(90deg,#22C55E,#16A34A)`,color:"#fff",border:"none"}}>✅ Concluir</Btn>
          <Btn variant="ghost" onClick={()=>setShowMatForm(!showMatForm)}>📦 Solicitar Material</Btn>
        </div>
      )}
      {s==="Pausada"&&(
        <Btn onClick={()=>colAction(svc,"Em Execução","Tarefa reiniciada")} variant="ghost">▶️ Recomeçar</Btn>
      )}
      {s==="Material Pendente"&&(
        <Btn onClick={()=>colAction(svc,"Em Execução","Retomado após materiais")} variant="ghost">⚡ Retomar Execução</Btn>
      )}

      {/* Justify delay — shown when overdue OR in execution/scheduled */}
      {(isOverdue||["Em Execução","Agendado","Emitido"].includes(s))&&(
        <Btn variant="ghost" onClick={()=>setShowDelayForm(!showDelayForm)}
          style={{borderColor:isOverdue?T.red:T.border,color:isOverdue?T.red:T.muted}}>
          {isOverdue?"🚨 Justificar Atraso":"⚠️ Registrar Impedimento"}
        </Btn>
      )}

      {/* Delay justification form */}
      {showDelayForm&&(
        <div style={{background:T.card2,borderRadius:12,padding:"14px 16px",border:`1px solid ${isOverdue?T.red+"44":T.border}`,marginTop:4}}>
          <div style={{fontWeight:700,color:isOverdue?T.red:T.yellow,fontSize:13,marginBottom:12}}>
            {isOverdue?"🚨 Justificativa de Atraso":"⚠️ Registrar Impedimento"}
          </div>

          {/* Pre-defined list */}
          <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:12}}>
            {(SYSTEM_LISTS_DEFAULTS.TASK_PAUSE_REASONS||[]).map((label,idx)=>({id:idx+1,icon:"⏸️",label})).map(j=>(
              <label key={j.id} style={{
                display:"flex",alignItems:"center",gap:10,padding:"8px 12px",
                borderRadius:8,cursor:"pointer",transition:"all .15s",
                border:`1px solid ${selectedJust?.id===j.id?(isOverdue?T.red:T.accent):T.border}`,
                background:selectedJust?.id===j.id?(isOverdue?`${T.red}12`:`${T.accent}12`):T.card,
              }}>
                <input type="radio" name={`just_${svc.id}`}
                  checked={selectedJust?.id===j.id}
                  onChange={()=>setSelectedJust(j)}
                  style={{accentColor:isOverdue?T.red:T.accent}}/>
                <span style={{fontSize:18}}>{j.icon}</span>
                <span style={{fontSize:13,color:selectedJust?.id===j.id?T.text:T.muted,fontWeight:selectedJust?.id===j.id?600:400}}>{j.label}</span>
              </label>
            ))}
          </div>

          {/* Custom text if "Outro" selected */}
          {selectedJust?.id===15&&(
            <div style={{marginBottom:12}}>
              <Input placeholder="Descreva o motivo do atraso..." value={customJust}
                onChange={e=>setCustomJust(e.target.value)}/>
            </div>
          )}

          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn size="sm" variant="ghost" onClick={()=>{setShowDelayForm(false);setSelectedJust(null);setCustomJust("");}}>Cancelar</Btn>
            <Btn size="sm"
              style={{background:isOverdue?T.red:T.yellow,color:"#fff",border:"none"}}
              onClick={()=>{
                if(!selectedJust){show("Selecione uma justificativa.","error");return;}
                if(selectedJust.id===15&&!customJust.trim()){show("Descreva o motivo.","error");return;}
                colAction(svc,"Pausada","Tarefa pausada",{pauseReason:selectedJust?.label||customJust,pauseNote:customJust||"",pausedAt:new Date().toISOString()});
                setShowDelayForm(false);setSelectedJust(null);setCustomJust("");
              }}>
              📋 Registrar
            </Btn>
          </div>
        </div>
      )}

      {/* Material request form */}
      {showMatForm&&(
        <div style={{background:T.card2,borderRadius:10,padding:"12px 14px",border:`1px solid ${T.border}`,marginTop:4}}>
          <div style={{fontWeight:700,color:T.text,fontSize:13,marginBottom:8}}>📦 Materiais Necessários</div>
          {matList.map((m,i)=>(
            <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 70px 60px 30px",gap:6,marginBottom:6}}>
              <Input placeholder="Item" value={m.name} onChange={e=>{const l=[...matList];l[i]={...l[i],name:e.target.value};setMatList(l);}}/>
              <Input type="number" min="1" placeholder="Qtd" value={m.qty} onChange={e=>{const l=[...matList];l[i]={...l[i],qty:Number(e.target.value)};setMatList(l);}}/>
              <Input placeholder="Un" value={m.unit} onChange={e=>{const l=[...matList];l[i]={...l[i],unit:e.target.value};setMatList(l);}}/>
              <button onClick={()=>setMatList(matList.filter((_,j)=>j!==i))} style={{background:"none",border:`1px solid ${T.red}`,borderRadius:6,color:T.red,cursor:"pointer",fontSize:14}}>×</button>
            </div>
          ))}
          <div style={{display:"flex",gap:8,marginTop:8}}>
            <Btn size="sm" variant="ghost" onClick={()=>setMatList([...matList,{name:"",qty:1,unit:"un"}])}>+ Item</Btn>
            <Btn size="sm" onClick={()=>{
              const valid=matList.filter(m=>m.name.trim());
              if(!valid.length){show("Informe ao menos um material.","error");return;}
              requestMaterials(svc,valid);
              setShowMatForm(false);
            }}>📦 Enviar Pedido</Btn>
          </div>
        </div>
      )}

      {/* Conclude form */}
      {showConcForm&&(
        <div style={{background:T.card2,borderRadius:10,padding:"12px 14px",border:`1px solid ${T.green}44`,marginTop:4}}>
          <div style={{fontWeight:700,color:T.green,fontSize:13,marginBottom:8}}>✅ Concluir Serviço</div>
          <Textarea rows={2} placeholder="Observações sobre a conclusão (opcional)..." value={concNote} onChange={e=>setConcNote(e.target.value)} style={{marginBottom:8}}/>
          {/* Optional photo upload */}
          <div style={{marginBottom:8}}>
            <div style={{fontSize:11,color:T.muted,marginBottom:4}}>📷 Fotos comprobatórias (opcional)</div>
            <input type="file" accept="image/*" multiple
              onChange={e=>{
                const files=Array.from(e.target.files);
                Promise.all(files.map(f=>new Promise(res=>{
                  const r=new FileReader();
                  r.onload=ev=>res(ev.target.result);
                  r.readAsDataURL(f);
                }))).then(photos=>setConcPhotos(p=>[...p,...photos]));
              }}
              style={{fontSize:12,color:T.muted,width:"100%"}}/>
            {concPhotos.length>0&&(
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:8}}>
                {concPhotos.map((ph,i)=>(
                  <div key={i} style={{position:"relative"}}>
                    <img src={ph} alt="" style={{width:64,height:64,objectFit:"cover",borderRadius:8,border:`1px solid ${T.border}`}}/>
                    <button onClick={()=>setConcPhotos(p=>p.filter((_,j)=>j!==i))}
                      style={{position:"absolute",top:-4,right:-4,background:T.red,border:"none",borderRadius:"50%",width:18,height:18,color:"#fff",cursor:"pointer",fontSize:11,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn size="sm" variant="ghost" onClick={()=>{setShowConcForm(false);setConcPhotos([]); }}>Cancelar</Btn>
            <Btn size="sm" onClick={()=>conclude(svc,concNote,concPhotos)} style={{background:T.green,color:"#fff",border:"none"}}>✅ Confirmar</Btn>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Service Detail + Timeline Modal ───────────────────────────────────────

export { ColActionButtons };
